//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

type StatusCirclesProps = {
  children: ReactNode;
};

export const StatusCircles = ({ children }: StatusCirclesProps) => <Circles>{children}</Circles>;

const Circles = styled.div`
  display: flex;
  align-items: center;
`;
